import { render } from "./SetupAccount.vue?vue&type=template&id=3a27435c&scoped=true"
import script from "./SetupAccount.vue?vue&type=script&lang=js"
export * from "./SetupAccount.vue?vue&type=script&lang=js"

import "./SetupAccount.vue?vue&type=style&index=0&id=3a27435c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a27435c"]])

export default __exports__